import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type NoticeItemType = {
  created_at: string;
  is_published: number;
  notice_id: number;
  published_from: string | null;
  published_to: string | null;
  title: string;
  updated_at: string;
};

export type NoticeItemDeatilType = {
  notice_id: number;
  content: string;
  published_from: string | null;
  published_to: string | null;
  is_published: number;
  created_at: string;
  updated_at: string;
};

export type WeatherNoticeItemType = {
  simple_notice_id: number;
  content: string;
  status: boolean;
  permission_groups: [
    {
      permission_type: number;
      store_ids: number[];
    },
  ];
  created_at: string;
  updated_at: string;
};

const NoticeController = {
  create: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/create';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  update: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/update';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delete: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/delete';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getlist: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/getlist';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 리스트 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getdetail: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/getdetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 상세 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  createNotice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/create';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 생성(필터) 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  updateNotice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/notice/admin/update';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[공지사항 수정(필터) 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  getWeatherNoticeList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/weatherNotices/admin/getList';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기상안내 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  createWeatherNotice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/weatherNotices/admin/create';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기상안내 생성 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  updateWeatherNotice: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/weatherNotices/admin/update';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기상안내 수정 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  deleteWeatherNoticeList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/weatherNotices/admin/delete';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[기상안내 삭제 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default NoticeController;
